'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

require('./styles.css');

var _utils = require('../../libs/utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ReCaptchaComponent = function (_Component) {
  _inherits(ReCaptchaComponent, _Component);

  function ReCaptchaComponent(props) {
    _classCallCheck(this, ReCaptchaComponent);

    var _this = _possibleConstructorReturn(this, (ReCaptchaComponent.__proto__ || Object.getPrototypeOf(ReCaptchaComponent)).call(this, props));

    _this.recaptchaID = (0, _utils.uniqueId)('recaptcha-container');
    return _this;
  }

  _createClass(ReCaptchaComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.grecaptcha.ready(function () {
        return _this2.renderReCaptcha();
      });
    }
  }, {
    key: 'getContainerClassNames',
    value: function getContainerClassNames() {
      var className = this.props.className;
      return (0, _classnames2["default"])('rainbow-recaptcha-container', className);
    }
  }, {
    key: 'renderReCaptcha',
    value: function renderReCaptcha() {
      var _props = this.props,
          siteKey = _props.siteKey,
          theme = _props.theme,
          size = _props.size,
          tabIndex = _props.tabIndex,
          onChange = _props.onChange;
      window.grecaptcha.render(this.recaptchaID, {
        sitekey: siteKey,
        theme: theme,
        size: size,
        tabIndex: tabIndex,
        callback: onChange,
        'expired-callback': onChange,
        'error-callback': onChange
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          error = _props2.error,
          style = _props2.style;
      return _react2["default"].createElement('div', {
        className: this.getContainerClassNames(),
        style: style
      }, _react2["default"].createElement('div', {
        id: this.recaptchaID
      }), _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: !!error
      }, _react2["default"].createElement('div', {
        className: 'rainbow-recaptcha_error'
      }, error)));
    }
  }]);

  return ReCaptchaComponent;
}(_react.Component);

exports["default"] = ReCaptchaComponent;
ReCaptchaComponent.propTypes = {
  siteKey: _propTypes2["default"].string.isRequired,
  theme: _propTypes2["default"].oneOf(['light', 'dark']).isRequired,
  size: _propTypes2["default"].oneOf(['normal', 'compact']).isRequired,
  tabIndex: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]).isRequired,
  error: _propTypes2["default"].oneOfType([_propTypes2["default"].node, _propTypes2["default"].string]),
  onChange: _propTypes2["default"].func.isRequired,
  className: _propTypes2["default"].string,
  style: _propTypes2["default"].object
};
ReCaptchaComponent.defaultProps = {
  error: undefined,
  onChange: function onChange() {},
  className: undefined,
  style: undefined
};